/** @module EngineeringChange/NewAffectedSpecsWizard */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def/Tab",
    "csi/table/New",
    "csi/wizard/ActionControllerMixin",
    "csi/xml",
    "csi/xml/Query",
    "./_AggregateSpecsMixin"
], function(declare,lang,Tab,New,ActionControllerMixin,xml,Query,_AggregateSpecsMixin) {

		return declare([New, ActionControllerMixin, _AggregateSpecsMixin], {
			idWizardResource: "NewAffectedSpecsWizard",

			/**
			 * @override
			 * Disable finish button
			 */
			disableFinish: function(wizard, page, index) {
				return index==0 || !this.m_formData.getSelectedNodes().length > 0;
			},

			/**
			 * @override
			 * Pass data into the next page
			 */
			onNextPage: function(wizard, currentPage, nextPage, bFinish) {
				const fd = this.m_formData;
				let bRefresh = false;
				if (wizard.getIndexOfPage(nextPage) == 1) {
					fd.resetSelections();
					bRefresh = true;
					const affectedItem = this.m_formData.getFieldValue("AffectedItems");
					nextPage.defTab = lang.mixin(new Tab(), {
						m_idView: "AggregateSpecs",
						m_url: affectedItem
					});
					nextPage.refreshTab(wizard.getContext());
				}

				return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
			},

			/**
			 * @override
			 * Add AffectedItemURL to the call parameters
			 */
			toWriterRequest: function(fd) {
				let call = this.inherited(arguments);
				const affectedItem = this.m_formData.getFieldValue("AffectedItems", true);
				call.addParameter("AffectedItemURL", xml.ATTR_REF, affectedItem);
				return call;
			}

		});
	});
